// Curated Monaco bundle. Importing the full `monaco-editor` barrel (`editor.main`)
// statically pulls in EVERY language contribution — including the TypeScript language
// service (`vs/language/typescript`), which alone is ~6.5 MB and dominated the bundle.
//
// `edcore.main` is the full editor (all editor features/contribs) with NO languages, so
// we add back only the ones we actually use. TypeScript/JavaScript IntelliSense is gone;
// boo/pm script autocomplete is provided by a custom provider (utils/booScriptCompletions).
//
// NOTE: keep the language list here in sync with `languages` in craco.config.js — the
// MonacoWebpackPlugin uses that list to decide which web workers to emit.
import * as monaco from 'monaco-editor/esm/vs/editor/edcore.main';

// Rich language services (with workers) — same set as before, minus TypeScript.
import 'monaco-editor/esm/vs/language/json/monaco.contribution';
import 'monaco-editor/esm/vs/language/html/monaco.contribution';
import 'monaco-editor/esm/vs/language/css/monaco.contribution';

// Basic languages — syntax highlighting only, no worker.
import 'monaco-editor/esm/vs/basic-languages/javascript/javascript.contribution';
import 'monaco-editor/esm/vs/basic-languages/xml/xml.contribution';
import 'monaco-editor/esm/vs/basic-languages/html/html.contribution';
import 'monaco-editor/esm/vs/basic-languages/css/css.contribution';
// SQL for the DB Manager query tab (SqlQueryEditor) — monarch grammar only;
// completions come from its schema-aware provider, no worker involved.
import 'monaco-editor/esm/vs/basic-languages/sql/sql.contribution';
// Dialects, because comment syntax is not shared. The generic 'sql' grammar
// knows only `--` and `/* */`, so MySQL's `#` line comment was not recognised
// at all: `# this QUERY` left QUERY tokenised as a keyword and highlighted
// mid-comment. 'mysql' handles `#`; 'pgsql' correctly does NOT, which is why
// this is per-dialect rather than one grammar with `#` bolted on.
import 'monaco-editor/esm/vs/basic-languages/mysql/mysql.contribution';
import 'monaco-editor/esm/vs/basic-languages/pgsql/pgsql.contribution';
// GraphQL for the request body's Query editor (GraphQLBodyEditor passes language="graphql").
// Without this the id is unknown to Monaco and the editor silently falls back to plaintext —
// a query with no colours at all (owner, 20.09.2026). Monarch grammar only, no worker.
import 'monaco-editor/esm/vs/basic-languages/graphql/graphql.contribution';
// The FTP/SFTP File Editor's highlighting by file type (owner, 06.10.2026:
// .php, .py, .yml … opened as plain text) — FileEditModal EXT_LANGUAGE.
// Monarch grammars only, a few KB each, loaded when first used; no workers.
import 'monaco-editor/esm/vs/basic-languages/php/php.contribution';
import 'monaco-editor/esm/vs/basic-languages/python/python.contribution';
import 'monaco-editor/esm/vs/basic-languages/yaml/yaml.contribution';
import 'monaco-editor/esm/vs/basic-languages/markdown/markdown.contribution';
import 'monaco-editor/esm/vs/basic-languages/shell/shell.contribution';
import 'monaco-editor/esm/vs/basic-languages/ini/ini.contribution';
import 'monaco-editor/esm/vs/basic-languages/dockerfile/dockerfile.contribution';
import 'monaco-editor/esm/vs/basic-languages/java/java.contribution';
import 'monaco-editor/esm/vs/basic-languages/go/go.contribution';
import 'monaco-editor/esm/vs/basic-languages/csharp/csharp.contribution';
import 'monaco-editor/esm/vs/basic-languages/cpp/cpp.contribution';
import 'monaco-editor/esm/vs/basic-languages/ruby/ruby.contribution';
import 'monaco-editor/esm/vs/basic-languages/rust/rust.contribution';
import 'monaco-editor/esm/vs/basic-languages/scss/scss.contribution';
import 'monaco-editor/esm/vs/basic-languages/less/less.contribution';
import 'monaco-editor/esm/vs/basic-languages/bat/bat.contribution';
import 'monaco-editor/esm/vs/basic-languages/powershell/powershell.contribution';
import 'monaco-editor/esm/vs/basic-languages/perl/perl.contribution';
import 'monaco-editor/esm/vs/basic-languages/lua/lua.contribution';
import 'monaco-editor/esm/vs/basic-languages/kotlin/kotlin.contribution';
import 'monaco-editor/esm/vs/basic-languages/swift/swift.contribution';

import { loader } from '@monaco-editor/react';
import { installMonacoWorkers } from './utils/monacoWorkers';

// Bundle Monaco locally. monaco-editor-webpack-plugin (craco) EMITS the web
// workers, but cannot point Monaco at them through edcore.main — see
// utils/monacoWorkers.
installMonacoWorkers();
loader.config({ monaco });
